import Image from 'next/image';
import { useTranslate, Translate } from '~/i18n';
import { publicUrl } from '~/utils/publicUrl';
import Container from '../common/container';
import styles from './app.module.css';
import classNames from 'classnames';
import { VisionIcon, HalaYallaBigLogo } from '~/svgs/common';
const AppSection = () => {
   const { lang, translate } = useTranslate();
   return (
      <div className="mt-64">
         <div
            className={classNames(
               'bg-primary-pink bg-left-top bg-no-repeat pb-56 relative text-primary-color',
               styles.section
            )}
            style={{ backgroundImage: 'url("/images/about-page/app-bg.svg")' }}>
            <Container>
               <div
                  id="app"
                  style={{ backgroundImage: 'url("/images/sand.jpg")' }}
                  className={classNames(
                     'relative pt-14 bg-no-repeat transform 2xl:-translate-y-2/3 -translate-y-1/2 w-full',
                     styles.fcontainer
                  )}>
                  <div className="flex rtl:flex-row-reverse items-center lg:px-20 sm:px-8 px-4 h-full">
                     <div className="xl:w-3/5 pb-16 self-end text-center lg:ltr:text-left lg:rtl:text-right">
                        <span className="block font-bold sm:text-3xl text-xl mb-6">
                           <Translate id="about:your super app" />
                        </span>
                        <span className="sm:text-xl text-lg block mb-8 tracking-tight">
                           <Translate id="about:discover things around you" />
                        </span>
                        <div className="flex items-center justify-center lg:justify-start">
                           <VisionIcon className="opacity-75" />
                           <HalaYallaBigLogo className="w-36 small:ltr:ml-8 ltr:ml-4 rtl:mr-4 rtl:-ml-4 small:rtl:mr-8 small:rtl:ml-0" />
                        </div>
                     </div>
                     <div className="w-2/5 hidden lg:block">
                        <div className={styles.flag}>
                           <Image src="/images/about-page/flag.png" width={552} height={403} />
                        </div>
                     </div>
                  </div>
               </div>

               <div className="text-center xl:-mt-56 -mt-40">
                  <span className="block font-medium mt-14">
                     <Translate id="about:the all new hy" />
                  </span>
                  <span className="block text-6xl italic font-bold mt-2 mb-3">
                     <Translate id="about:super app" />
                  </span>
                  <span className="block text-xl">
                     <Translate id="about:one stop for fun" />
                  </span>
                  <div className="flex mt-5 rtl:space-x-reverse justify-center flex-wrap space-x-2 pb-48">
                     <a
                        target="_blank"
                        rel="noreferrer noopener"
                        aria-label="Download from the appstore"
                        href="https://apps.apple.com/us/app/webook-com-fun-things-to-do/id6468667896">
                        <Image
                           key={`appstore${lang}`}
                           src={publicUrl(
                              lang === 'sa-ar' ? 'images/appstore_ar.svg' : 'images/appstore.svg'
                           )}
                           alt={translate({ id: 'seo:home alt' })}
                           width={140}
                           height={41}
                        />
                     </a>
                     <a
                        target="_blank"
                        rel="noreferrer noopener"
                        aria-label="Download from the playstore"
                        href="https://play.google.com/store/apps/details?id=com.webook.android">
                        <Image
                           key={`playstore${lang}`}
                           src={publicUrl(
                              lang === 'sa-ar' ? 'images/playstore-ar.svg' : 'images/playstore.svg'
                           )}
                           alt={translate({ id: 'seo:home alt' })}
                           width={140}
                           height={41}
                        />
                     </a>
                  </div>
                  <div className="flex justify-center absolute -bottom-32 inset-x-0 w-full">
                     <Image
                        className="object-cover"
                        width={338}
                        height={560}
                        src="/images/about-page/device.png"
                     />
                  </div>
               </div>
            </Container>
         </div>
      </div>
   );
};

export default AppSection;
